import { isBalanceLow } from "@/features/billing/billingAlerts";
import { interlude } from "@/interlude";

/**
 * `true` when the org's available balance is at or below its alert threshold,
 * `false` when it is above, and `undefined` until both have loaded or when the
 * org has no subscription (the endpoints answer 400/404), so callers show
 * nothing rather than guess.
 */
export const useLowBalance = (): boolean | undefined => {
  const balanceQuery = interlude.balance.useGetBalance();
  const thresholdQuery = interlude.balance.useGetBalanceThreshold();
  if (!balanceQuery.isSuccess || !thresholdQuery.isSuccess) return undefined;
  return isBalanceLow(
    balanceQuery.data.availableBalance,
    thresholdQuery.data.threshold,
  );
};
